import { get, capturedGet, capturedPost, remove } from '../../http';

import Page from '@/global/util/Page';
const FALLBACK_AD_LIST_DATA = 'FALLBACK_AD_LIST_DATA'
const FALLBACK_AD_FLOW_TYPE_MENU = 'FALLBACK_AD_FLOW_TYPE_MENU' // 流量类型
const FALLBACK_AD_PORT_TYPE_MENU = 'FALLBACK_AD_PORT_TYPE_MENU' // 投放终端
const FALLBACK_AD_PLACE_ATTRIBUTE_MENU = 'FALLBACK_AD_PLACE_ATTRIBUTE_MENU' // 广告位属性
const FALLBACK_AD_JUMP_TYPE_MENU = 'FALLBACK_AD_JUMP_TYPE_MENU' // 跳转类型
const state = {
  fallback: {
    page: new Page(),
    dataUrl: '',
    flowTypeMenu: [],
    curFlowType: '',
    portTypeMenu: [],
    curPortType: '',
    placeAttrMenu: [],
    curPlaceAttr: '',
    jumpTypes: [],
    curJumpType: ''
  }
}

const getters = {
  fallback: state => state.fallback
}

const actions = {
  async getCommonPlace({ state, commit }, { params, data, api, isAll, mediaType } = {}) {
    await get('/inner/v2/basicPlace/' + params, data).then(res => {
      if (res.code === 1) {
        commit(api, { result: res.data, isAll, data })
      }
    })
  },
  async getMaterialSizes({ state, commit }, params) {
    return await capturedGet('/inner/v2/getSizes', { ...params })
  },
  async checkAdUrl(context, { platform, type, url, jumpType }) {
    return await capturedGet(`/${platform}/ads/ad/handle_url`, { conversion_monitor_type: type, url, jump_type: jumpType })
  },
  async uploadPicture(context, { platform, isMaterial, formData }) {
    return await capturedPost(`/${platform}/ads/ad/upload`, formData, { 'Content-Type': 'multipart/form-data' })
  },
  async uploadVideo(context, { platform, formData }) {
    return await capturedPost(`/inner/v2/upload-video`, formData, { 'Content-Type': 'multipart/form-data' })
  },
  async uploadMaterialCut(context, { platform, formData }) {
    return await capturedPost(`/inner/v2/materials-upload-cut`, formData, { 'Content-Type': 'multipart/form-data' })
  },
  async handleOnRemove(context, { platform, ids }) {
    return await capturedPost(`/inner/v2/basicMaterial/${ids}`)
  },
  async batchStart(context, { platform, ids }) {
    return await capturedPost(`/inner/v2/basicAd/start/${ids}`)
  },
  async batchStop(context, { platform, ids }) {
    return await capturedPost(`/inner/v2/basicAd/pause/${ids}`)
  },
  async stopFallbackAd({ state, commit }, params) {
    return await remove('/inner/v2/basicAd/' + params)
  },
  async getItems(context, { keys }) {
    return await Promise.all(
      [...keys].map(item =>
        get(`/interface/etcd/item/${item}`)
      )
    )
  },
  async isRepeatedName({ state, commit }, params) {
    return await get(`/inner/v2/is-repeated`, { ...params })
  },
  getFallbackList(
    { commit, state },
    {
      pageSize = state.fallback.page.pageSize,
      currentPage = state.fallback.page.currentPage
    } = {}
  ) {
    let params = {};
    params.page = currentPage;
    params.per_page = pageSize;
    get('/inner/v2/basicAd', params).then(res => {
      if (res.code === 1) {
        commit(FALLBACK_AD_LIST_DATA, res.data);
      }
    });
  }
}

const mutations = {
  [FALLBACK_AD_FLOW_TYPE_MENU](state, result) {
    state.fallback.flowTypeMenu = result.result
    state.fallback.curFlowType = result.result.length ? result.result[0].value : ''
  },
  [FALLBACK_AD_PORT_TYPE_MENU](state, result) {
    state.fallback.portTypeMenu = result.result
    state.fallback.curPortType = result.result.length ? result.result[0].value : ''
  },
  [FALLBACK_AD_PLACE_ATTRIBUTE_MENU](state, result) {
    state.fallback.placeAttrMenu = result.result
    state.fallback.curPlaceAttr = result.result.length ? result.result[0].value : ''
  },
  [FALLBACK_AD_JUMP_TYPE_MENU](state, result) {
    state.fallback.jumpTypes = result.result.filter(item => {
      return item.value !== '3'
    })
    state.fallback.curJumpType = result.result.length ? result.result[0].value : ''
  },
  [FALLBACK_AD_LIST_DATA](state, data) {
    state.fallback.page.setPageData(
      {
        header: data.header,
        data: data.data.data,
        total: data.data.total
      },
      false
    )
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
